import mobileAdjustment from "../GeneralMobileAdjustments";

class MobilePlayFormButtonControlView {

    constructor() {}

    afterRender(control) {
        let element = mobileAdjustment.adjustMobileControl(control);
        mobileAdjustment.setButtonsHeight(element);
    }
}

const mobilePlayFormButtonControlView = new MobilePlayFormButtonControlView();
export default mobilePlayFormButtonControlView;